<template>
  <div class="search-box">
    <v-row justify="space-between" class="form-row">
      <v-col cols="9">
        <v-form ref="form">
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="fileKey"
                clearable
                label="文件名称"
                outlined
                hide-details
                dense
                placeholder="请输入"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="reportType"
                :items="downloadList"
                label="文件类型"
                hide-details
                clearable
                outlined
                dense
                placeholder="请选择"
              ></v-select>
            </v-col>

            <v-col cols="5">
              <v-menu
                ref="menuRegister"
                v-model="showRegister"
                :eager="false"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                min-width="auto"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    :append-icon="icons.mdiCalendarRange"
                    outlined
                    dense
                    clearable
                    hide-details
                    label="生成时间"
                    placeholder="请选择"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" range no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="showRegister = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuRegister.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-col>

      <v-col class="btn-groups d-flex align-start justify-end" cols="2">
        <v-btn small width="56" height="32" class="mr-2" @click="resetForm">
          重置
        </v-btn>
        <v-btn
          small
          width="56"
          height="32"
          color="primary"
          class="mr-2 color-white"
          @click="handleClick"
        >
          搜索
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from 'vue'
import { mdiCalendarRange, mdiMenuDown } from '@mdi/js'
import { downloadList } from '@/request/api/common'

export default {
  emits: ['handleSearch'],
  setup(props, { emit }) {
    const selectList = reactive({
      downloadList,
    })

    const menuConfig = reactive({
      showRegister: false,
    })

    const formState = reactive({
      fileKey: '',
      reportType: '',
      date: [],
    })

    const handleClick = () => {
      emit('handleSearch', formState)
    }

    const form = ref(null)
    // 重置
    const resetForm = () => {
      form.value.reset()
      formState.date = []
      emit('handleSearch', formState)
    }

    return {
      icons: { mdiCalendarRange, mdiMenuDown },
      ...toRefs(menuConfig),
      ...toRefs(formState),
      ...toRefs(selectList),
      handleClick,
      form,
      resetForm,
    }
  },
}
</script>
